import type { ChatItem } from '@/features/ai/lib/chatFromEvents'
import type { AnswerGateFailure } from '@/features/ai/useAnswerGate'
import { GateCard } from './GateCard'

interface Props {
  item: ChatItem
  onAnswerGate: (gateId: number, optionKey: string) => void
  isAnsweringGate: boolean
  /** Отказ последнего клика по гейту — проброс до `GateCard` (Important 1). */
  gateFailure: AnswerGateFailure | null
}

/**
 * Реплика автора — вправо, акцентом; событие прогона — влево, приглушённо.
 * `stage` события — свободная строка сервера (см. CLAUDE.md), логика по ней
 * не ветвится, поэтому обе ветки рисуют один и тот же текстовый пузырь.
 * Вопрос прогона — своя карточка (`GateCard`), пропы приходят СВЕРХУ, чтобы
 * пузырь остался чистым компонентом без своего состояния.
 */
export const ChatBubble = ({ item, onAnswerGate, isAnsweringGate, gateFailure }: Props) => {
  if (item.kind === 'user') {
    return (
      <div className="flex justify-end">
        <div className="max-w-[85%] rounded-2xl rounded-tr-md bg-primary px-3.5 py-2.5 text-sm text-primary-foreground [overflow-wrap:anywhere]">
          {item.text}
        </div>
      </div>
    )
  }

  if (item.kind === 'gate') {
    return (
      <div className="flex justify-start">
        <GateCard
          gate={item.gate}
          onAnswer={(optionKey) => onAnswerGate(item.gate.id, optionKey)}
          isAnswering={isAnsweringGate}
          gateFailure={gateFailure}
        />
      </div>
    )
  }

  return (
    <div className="flex justify-start">
      <div className="max-w-[85%] rounded-2xl rounded-tl-md bg-muted/50 px-3.5 py-2.5 text-sm text-foreground [overflow-wrap:anywhere]">
        {item.text}
      </div>
    </div>
  )
}
